import styled from '@emotion/styled';
import { FC } from 'react';
import Div100vh from 'react-div-100vh';

import LoadingSpinner from 'app/components/v2/components/LoadingSpinner';

// Local Variables
const StyledDiv100vh = styled(Div100vh)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  width: '100vw',
});

// Component Definition
const LoadingScreen: FC = () => (
  <main>
    <StyledDiv100vh>
      <LoadingSpinner />
    </StyledDiv100vh>
  </main>
);

export default LoadingScreen;
